package com.royceecoleman.bill.shared.billing

import kotlinx.serialization.Serializable

/**
 * One wording check, run in code on every entry. [pattern] is a word, phrase or punctuation, matched in any
 * capitalization: words match whole words only, `*` matches the rest of a word (`schedul*` matches "schedule" and
 * "scheduling"), and spaces match any run of spaces. A non-null [replacement] offers a one-click fix; an empty one
 * deletes the match. A [blocking] check stops approval, as prohibited wording does; otherwise it warns.
 */
@Serializable
data class WordingCheck(
    val id: String = "",
    val pattern: String = "",
    val replacement: String? = null,
    val message: String = "",
    val blocking: Boolean = false,
) {
    companion object {
        const val MAX_CHECKS = 200
        const val MAX_PATTERN = 100
        const val MAX_REPLACEMENT = 100
        const val MAX_MESSAGE = 300
        const val MAX_WILDCARDS = 3
    }
}

/** An account's wording checks, kept beside its standing rules and applied to every workspace. */
@Serializable
data class WordingChecks(
    val checks: List<WordingCheck> = emptyList(),
    /** 0 until the first save. */
    val revision: Int = 0,
    val updatedAt: Long = 0,
)

@Serializable
data class WordingChecksEdit(
    val revision: Int,
    val checks: List<WordingCheck>,
)

/** Checks BILL proposes from the standing rules. Nothing is saved until the lawyer accepts them. */
@Serializable
data class WordingCheckSuggestions(
    val suggestions: List<WordingCheck> = emptyList(),
    /** Today's rules chats left; each suggestion request uses one. */
    val chatsRemaining: Int = 0,
)
